import { useState } from "react";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AirIcon from "@mui/icons-material/Air";
import BiotechIcon from "@mui/icons-material/Biotech";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SpaIcon from "@mui/icons-material/Spa";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
export const TopInnoTracks = () => {
   const [chevron, setChevron] = useState(0);
   const [margin1, setMargin1] = useState("0vw");
   const [chevron2, setChevron2] = useState(0);
   const [margin2, setMargin2] = useState("0vw");

   return (
      <>
         <section
            id="tracks"
            className="section mb-0"
            style={{
               backgroundColor: "rgb(25, 25, 25)",
               fontFamily: "Roboto Condensed, sans-serif !important",
               overflow: "hidden",
            }}
         >
            <div className="container">
               <div className="row">
                  <div className="col-12">
                     <h1 className="text-center top-innovators">
                        Call For Top Innovators!
                     </h1>
                     <hr className="lines theme-color-primary" />

                     <div className="row">
                        <div
                           className="col-12 "
                           style={{ marginTop: "2%", textAlign: "center" }}
                        >
                           <img alt='youngstartup'
                              className=" lazy callForTopPic "
                              data-src="https://youngstartup.com/wp-content/uploads/2019/12/Top-Innovators-New-Pic.png"
                           />
                        </div>
                     </div>
                     <div
                        className="top-inno-p"
                        style={{
                           textAlign: "center !important",
                           justifyContent: "center",
                           fontSize: "1.5rem",
                        }}
                     >

                        <span style={{ textAlign: "center" }}>
                           A select group of more than{" "}
                        </span>
                        <span
                           className="theme-color-primary"
                           style={{ fontWeight: "800" }}
                        >
                           100 Top Innovators
                        </span>{" "}
                        <span style={{ textAlign: "center" }}>
                           from the Technology, CleanTech, Life Sciences, Healthcare,
                           MedTech and FinTech sectors will be chosen to present their
                           breakthrough investment opportunities to an exclusive audience
                           of Venture Capitalists, Corporate Investors, Private
                           Investors, Investment Bankers, and Strategic Partners.
                        </span>
                     </div>
                     <h2
                        style={{
                           color: "white",
                           textAlign: "center",
                           marginTop: "7.5vh",
                        }}
                     >
                        Featured Company Benefits include:
                     </h2>
                     <ul
                        style={{
                           textAlign: "left",
                           color: "white",
                           margin: "auto",
                           paddingBottom: "5vh",
                           maxWidth: "70%",
                           fontSize: "1.5rem",
                        }}
                     >
                        <li>
                           <div className="inno-header">1-on-1 Networking Sessions</div>
                           <div>
                              Connect and meet with active investors over the course of
                              two and a half days leveraging our meeting app and
                              conferencing solutions
                           </div>
                        </li>
                        <br />
                        <li>
                           <div className="inno-header">
                              Top Innovator Presentation Slot
                           </div>
                           <div>
                              Gain visibility for your venture by presenting live and
                              being recognized as one of the Top Innovators
                           </div>
                        </li>
                        <br />
                        <li>
                           <div className="inno-header">
                              Featured Company Coaching Session
                           </div>
                           <div>
                              Opportunity to present to active investors and receive
                              crucial feedback that will help you improve your game for
                              the main presentation.
                           </div>
                        </li>
                        <br />
                        <li>
                           <div className="inno-header">Featured Company Profiles</div>
                           <div>
                              Presenters have their 2 page company profile included in the
                              event guide which is distributed to all attendees and
                              investors.
                           </div>
                        </li>
                        <br />
                        <li>
                           <div className="inno-header">
                              Access to Venture Investor Panels + Round Tables
                           </div>
                           <div>
                              Watch and hear interactive sessions, where leading investors
                              and experts will discuss key issues facing startups and
                              venture investors alike.
                           </div>
                        </li>
                     </ul>
                     <div
                        className="text-center font-weight-bold to-apply"
                        style={{ marginRight: "25%", marginLeft: "25%" }}
                     >
                        <h2>To apply, your company must be:</h2>
                        <br />
                        <ul
                           style={{
                              textAlign: "left",
                              margin: "auto",
                              width: "fit-content",
                              fontSize: "1.25rem",
                           }}
                        >
                           <li>1. Privately held</li>
                           <li>2. Seeking 1M USD or more</li>
                           <li>3. Ideally in one of the following industry sectors</li>
                        </ul>
                     </div>
                     <br />
                  </div>
               </div>
               <div className="row tracks-row text-center">
                  <div className="col-md-3 track foo turn-me-grey">
                     <div className="tracks-icon">
                        <PowerSettingsNewIcon />
                     </div>

                     <div className="track-title highlight-color">
                        <h4>Tech</h4>
                     </div>
                     <div className="track-list">
                        <ul>
                           <li className="underline">Mobile</li>
                           <li className="underline">Internet/Digital Media</li>
                           <li className="underline">IoT</li>
                           <li className="underline">Security</li>
                           <li className="underline">Software/IT</li>
                           <li className="underline">EdTech</li>
                           <li>Robotics</li>
                        </ul>
                     </div>
                  </div>

                  <div className="col-md-3 track foo">
                     <div className="tracks-icon">
                        <AccountBalanceIcon />
                     </div>
                     <div className="track-title highlight-color">
                        <h4>FinTech</h4>
                     </div>
                     <div className="track-list">
                        <ul>
                           <li className="underline">Banking</li>
                           <li className="underline">Blockchain</li>
                           <li className="underline">Insurtech</li>
                           <li className="underline">Personal Finance</li>
                           <li className="underline">Payments</li>
                           <li>Predictive Analytics</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-md-3 track foo turn-me-grey">
                     <div className="tracks-icon">
                        <AirIcon />
                     </div>
                     <div className="track-title highlight-color">
                        <h4>CleanTech</h4>
                     </div>
                     <div className="track-list">
                        <ul>
                           <li className="underline">Energy Efficiency</li>
                           <li className="underline">Energy Generation</li>
                           <li className="underline">Energy Infrastructure</li>
                           <li className="underline">Energy Storage</li>
                           <li className="underline">Transportation</li>
                           <li className="underline">Water &amp; Wastewater</li>
                           <li>AgriTech</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-md-3 track foo">
                     <div className="tracks-icon">
                        <HealthAndSafetyIcon />
                     </div>
                     <div className="track-title highlight-color">
                        <h4>MedTech</h4>
                     </div>
                     <div className="track-list">
                        <ul>
                           <li className="underline">Medical Devices</li>
                           <li className="underline">Diagnostics</li>
                           <li className="underline">Monitoring</li>
                           <li className="underline">Wearables</li>
                           <li className="underline">AI Solutions</li>
                           <li>Medical AR</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-md-3 track foo">
                     <div className="tracks-icon">
                        <BiotechIcon />
                     </div>
                     <div className="track-title highlight-color">
                        <h4>Life Sciences / Healthcare</h4>
                     </div>
                     <div className="track-list">
                        <ul>
                           <li className="underline">BioTech</li>
                           <li className="underline">Drug Discovery</li>
                           <li className="underline">Healthcare IT</li>
                           <li className="underline">Pharma</li>
                           <li>Healthcare</li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>

            <div className="row tracks-row text-center mb-5">
               <div
                  className="col-12"
                  style={{ display: "flex", justifyContent: "center" }}
               >
                  <a
                     rel='noreferrer'
                     href={"https://account.youngstartup.com"}
                     target={"_blank"}
                     onMouseOver={(e) => {
                        setChevron(1);
                        setMargin1("1.5vw");
                     }}
                     onMouseLeave={() => {
                        setChevron(0);
                        setMargin1("0vw");
                     }}
                     className="btn btn-primary mr-2 mb-2 text-nowrap dark-btn"
                     style={{
                        marginRight: "1rem",
                        marginTop: "5vh",
                        fontWeight: "900",
                        fontSize: "18px",
                        display: "flex",
                     }}
                  >
                     <ChevronRightIcon sx={{ transition: "opacity 2s", opacity: 0 }} />
                     <div>APPLY TO PRESENT</div>
                     <ChevronRightIcon
                        sx={{
                           transition: ".3s all ease-in-out",
                           opacity: chevron,
                           marginLeft: margin1,
                        }}
                     />
                  </a>
               </div>
               <div
                  className="row tracks-row text-center"
                  style={{ marginTop: "5vh" }}
               >
                  <div className="col track spf-track foo">
                     <div className="tracks-icon">
                        <SpaIcon />
                     </div>
                     <div className="track-title highlight-color">
                        <h2 className="track-title">Seed Stage Track</h2>
                     </div>
                     <br />
                     <div
                        className="text-center to-apply"
                        style={{ marginRight: "25%", marginLeft: "25%" }}
                     >
                        <h3>
                           If you’re seeking an earlier Seed round of funding or an Angel
                           investor, our dedicated Seed Stage Track has you covered! To
                           be eligible, your company must be:
                        </h3>
                        <br />
                        <ul
                           style={{
                              textAlign: "left",
                              margin: "auto",
                              width: "fit-content",
                              fontSize: "1.25rem",
                           }}
                        >
                           <li>1. Privately held</li>
                           <li>2. Seeking less than 1M USD</li>
                           <li>3. Raised less than 500K USD to date</li>
                        </ul>
                     </div>
                     <br />
                  </div>
               </div>
               <a
                  rel='noreferrer'
                  href={"https://account.youngstartup.com"}
                  target={"_blank"}
                  onMouseOver={(e) => {
                     setChevron2(1);
                     setMargin2("1.5vw");
                  }}
                  onMouseLeave={() => {
                     setChevron2(0);
                     setMargin2("0vw");
                  }}
                  className="btn btn-primary mr-2 mb-2 text-nowrap dark-btn"
                  style={{
                     marginRight: "1rem",
                     marginTop: "5vh",
                     fontWeight: "900",
                     fontSize: "18px",
                     display: "flex",
                     width: 'fit-content'
                  }}
               >
                  <ChevronRightIcon sx={{ transition: "opacity 2s", opacity: 0 }} />
                  <div>APPLY TO PRESENT</div>
                  <ChevronRightIcon
                     sx={{
                        transition: ".3s all ease-in-out",
                        opacity: chevron2,
                        marginLeft: margin2,
                     }}
                  />
               </a>
            </div>
         </section>
         <img alt='group' src="./assets/media/group-109.png" style={{ width: "100%" }} />
      </>
   );
};
